import { Directive, EventEmitter, Input, Output } from '@angular/core';

import { ModalRoleEnum } from '~/component/modal/enums/role.enum';

@Directive()
export abstract class AbstractModal {
  @Input() public autoClose = true;
  @Input() public hasCloseButton = true;
  @Input() public role = ModalRoleEnum.Dialog;

  @Output() public readonly modalClose = new EventEmitter<boolean>();

  public isVisible = false;

  public abstract hide(): void;

  public abstract show(): void;

  public closeModal(): void {
    this.modalClose.emit(true);
  }
}
